module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-1-today-now"
    }
  }, [_c('h1', [_vm._v("Chapter 1 "), _c('br'), _vm._v("Today Now")]), _vm._v(" "), _c('p', [_vm._v("I fall to my knees, a tear running down my face. “Daddy’s home,” I say as my son comes to me with outstretched arms. He wants his dad, and for me to give him the biggest hug ever. All I wanted to do over the last few days was to get home, to see my wife and my four-year-old son. I wanted to make sure that they were safe – that they were okay. It’s taken me a long time to finally get home. I must admit I didn’t think I would make it more than once with all the crazy shit going on out there. I’ve seen a lot of shit over the past few days. I’m still numb with shock, to be honest. How the hell did things get so bad so quickly. I can feel the tears flow now as I allow my emotions to get the better of me. I have never been one for showing my feelings. Never been one for crying but right now I don’t care as I sob uncontrollably. I have made it home.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0